import {colors} from '@bettermarks/bm-ui-components';
import React from 'react';

export const TrashIcon: React.FC<React.SVGAttributes<SVGElement>> = ({
  fill
}) => (
  <svg
    width='26'
    height='26'
    viewBox='0 0 26 26'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M22.2084 3.25H18.9584V0H7.0417V3.25H3.05176e-05V4.33333H3.7917V26H22.2084V4.33333H26V3.25H22.2084ZM8.12503 1.08333H17.875V3.25H8.12503V1.08333ZM21.125 24.9167H4.87503V4.33333H21.125V24.9167ZM8.12503 21.6667H9.20836V6.5H8.12503V21.6667ZM12.4584 21.6667H13.5417V6.5H12.4584V21.6667ZM16.7917 21.6667H17.875V6.5H16.7917V21.6667Z'
      fill={fill || colors.cBlue700}
    />
  </svg>
);
